import { Component, inject, Input, OnInit, TemplateRef, ViewChild, AfterViewInit, ElementRef, Renderer2, OnDestroy } from '@angular/core';
import { BaseComponent } from '../../../shared/utils/base.component';
import { SectionsService } from '../../../services/sections.service';
import { ENROLLMENT_TYPE_BACKEND_MAPPINGS, STATIC_DATA, PROVIDER_TYPES, RADIO_YES_NO_OPTIONS, STATIC_JSON_DATA_PATH } from '../../../shared/constants/static-data.constants';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { CommonModule } from '@angular/common';
import { ReferralDataService } from '../../../services/referral-data.service';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { EnrollmentDataService } from '../../../services/enrollment-data.service';
import { DeleteAssociationModel, PrtcpntPrvdrAssociationModel } from '../../../shared/interfaces/participant-association.model';
import { EditMode } from '../../../interfaces/edit-mode.model';
import { DialogConfig, DialogService } from '../../../shared/services/dialog.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { AutoFocusHeaderDirective } from '../../../shared/directives/auto-focus-header.directive';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'ppl-new-contact',
  standalone: true,
  imports: [
    NzCardModule,
    NzFormModule,
    ReactiveFormsModule,
    NzToolTipModule,
    NzRadioModule,
    CommonModule,
    ButtonComponent,
    NzCollapseModule,
    ListTableComponent,
    AutoFocusHeaderDirective
  ],
  templateUrl: './new-contact.component.html',
  styleUrls: ['./new-contact.component.css'],
})
export class NewContactComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() mode = 'edit';
  readonly editMode = EditMode;
  radioOptions = RADIO_YES_NO_OPTIONS;
  newContactForm!: FormGroup;
  show = false;
  associationDetailsData: any = {};
  entry: string | null = '';
  associations: any = [];
  flow = '';
  program: any;

  cols: any = [];
  participantCols: any[] = [];
  associationCols: any = [];
  participantAssociations: any[] = [];
  mandatoryAssociations: any[] = [];
  isStepMandatory = false;
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  @ViewChild('deleteConfirmationDialog') deleteConfirmationDialog!: TemplateRef<any>;
  @ViewChild('a1yStatus', { static: true }) ariaStatus!: ElementRef<HTMLElement>;
  private announceSeq = 0;
  private dialogSvc = inject(DialogService);
  private destroy$ = new Subject<void>();
  isMobileView = window.innerWidth <= 768;
  isConsumerAbove18 = true;
  consumerData: any;
  participantId: any;

actions: any = {
  "edit": false,
  "delete": false,
  "view": true,
  "download": false,
  "verify": false,
  "add": false
}

  constructor(
    private sectionsService: SectionsService,
    private fb: FormBuilder,
    private referralDataService: ReferralDataService,
    private enrollmentDataService: EnrollmentDataService,
    private userService: UserService,
    private storageService: StorageService,
    private leadDetailsService: LeadDetailsService,
    private renderer: Renderer2,
    private hostEl: ElementRef<HTMLElement>
  ) {
    super();
  }

  activeKeys: string[] = [];
  allPanelsExpanded = false;

  private headerLabelToIndex: Record<string, string> = {
    'Employer Details': '1',
    'Designated Representative Details': '2',
    'Personal Assistant Details': '3',
    'Vendor Details': '4',
    'Independent Contractor Details': '5',
    'Legal Guardian Details': '6',
    'POA Details': '7'
  };

  ngOnInit(): void {
    this.newContactForm = this.fb.group({
      newEmployer: ['No'],
      newAuthRep: ['No'],
      newVendor: ['No'],
      newProvider: ['No'],
      newContractor: ['No'],
      newPOA: ['No'],
      newLegalGuardian: ['No'],
    });
    this.entry = this.userService.getLeadEntry() ?? '';
    this.flow = this.sectionsService.getFlow() ?? '';
    this.program = this.userService.getSelectedProgram();
    const steps = this.sectionsService.getSectionData(this.program.program_code);
    // const leadId = this.userService.getSelectedLead()!;
    this.participantId = this.storageService.getParticipantId()!;
    this.secData = steps['associations'];
    this.mandatoryAssociations = this.secData.attributes.filter((data:any)=>{
      return data.mandatory === 'Y';
    });

    console.log("this.mandatoryAssociations--------------", this.mandatoryAssociations);
    if(this.sectionsService.getFlow() === 'providerEnrollment'){
      this.mode = 'read'
      // this.referralDataService.setReferralFormData(
      //   'isAssociationsFormDirty',true
      // );
      // this.referralDataService.setReferralFormData(
      //   'isAssociationsFormUpdated',true
      // );
    }

    const controls = [
      'newEmployer',
      'newAuthRep',
      'newProvider',
      'newVendor',
      'newContractor',
      'newLegalGuardian',
      'newPOA',
    ];

    controls.forEach((control) => {
      this.newContactForm.get(control)?.valueChanges.subscribe((value) => {
        this.onRadioChange(control, value);
      });
    });

    const data = this.sectionsService.getAllSteps(this.program.program_code);
    const associationStep = data.find((step: any) => step.step_id === STATIC_DATA.ASSOCIATIONS);
    this.isStepMandatory = associationStep ? associationStep.isMandatory === 'Y' : false;
    this.getGridHeaders();
    this.getFileCols();
    this.getAssocGridHeaders();
    this.enrollmentDataService.getParticipantAssocChanged().subscribe(() => {
      this.getAssociationDetails(this.program.program_code, this.participantId);

    })
    //this.getAssociationDetails(program.program_code, leadId);
    if (this.sectionsService.getFlow() === 'providerEnrollment') {
      const filledData = this.referralDataService.getReferralDetails(
        'participantAssociations'
      )!;
      if (filledData) {
        this.associations = filledData;
      }
    }
    else{
      this.getConsumerDetails();
    }
    this.referralDataService.nextClicked.subscribe((val) => {
      if(val === STATIC_DATA.ASSOCIATIONS){
        this.referralDataService.setStepValidation({step: STATIC_DATA.ASSOCIATIONS, val: this.checkFieldData()});
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.makeHeadersFocusable(), 0);

    this.enrollmentDataService.getParticipantAssocChanged()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => setTimeout(() => this.makeHeadersFocusable(), 0));
  }

  private makeHeadersFocusable(): void {
    const root = this.hostEl.nativeElement;
    const headers = root.querySelectorAll<HTMLElement>('.ant-collapse-header');

    headers.forEach((hdr) => {
      const label = (hdr.querySelector('.ant-collapse-header-text')?.textContent || hdr.textContent || '').trim();
      const panelIndex = this.headerLabelToIndex[label] || '';
      if (!panelIndex) return;

      const headerId = `assoc-panel-${panelIndex}-header`;
      this.renderer.setAttribute(hdr, 'id', headerId);
      this.renderer.setAttribute(hdr, 'tabindex', '0');
      this.renderer.setAttribute(hdr, 'role', 'button');
      this.renderer.setAttribute(hdr, 'aria-controls', `assoc-panel-${panelIndex}-content`);
      this.renderer.setAttribute(hdr, 'aria-expanded', this.isPanelActive(panelIndex) ? 'true' : 'false');

      hdr.onkeydown = (ev: KeyboardEvent) => {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          const willExpand = !this.isPanelActive(panelIndex);
          this.togglePanel(panelIndex);
          setTimeout(() => {
            this.renderer.setAttribute(hdr, 'aria-expanded', this.isPanelActive(panelIndex) ? 'true' : 'false');
            this.announce(`${this.getHeaderText(panelIndex)} ${willExpand ? 'expanded' : 'collapsed'}`);
            if (willExpand) {
              this._focusContent(panelIndex, hdr);
            } else {
              this._focusNextHeader(hdr);
            }
          }, 0);
        }
      };
    });
  }

  private _focusContent(panelIndex: string, headerElement: HTMLElement): void {
    const root = this.hostEl.nativeElement;
    const isExpanded = this.isPanelActive(panelIndex);
    this.renderer.setAttribute(headerElement, 'aria-expanded', String(isExpanded));

    if (isExpanded) {
      const content = root.querySelector<HTMLElement>(`[id="assoc-panel-${panelIndex}-content"]`);
      const firstFocusable = content?.querySelector<HTMLElement>(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      firstFocusable ? firstFocusable.focus() : headerElement.focus();
    } else {
      this._focusNextHeader(headerElement);
    }
  }

  private _focusNextHeader(currentHeader: HTMLElement): void {
    const root = this.hostEl.nativeElement;
    const headers = Array.from(root.querySelectorAll<HTMLElement>('.ant-collapse-header'));
    const idx = headers.indexOf(currentHeader);
    const next = headers[idx + 1] || headers[0];
    next?.focus();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private announce(msg: string) {
    const el = this.ariaStatus?.nativeElement;
    if (!el) return;
    el.textContent = '';
    setTimeout(() => { el.textContent = msg; }, 30);
  }

  private getHeaderText(panelIndex: string): string {
    const root = this.hostEl.nativeElement;
    const hdr = root.querySelector<HTMLElement>(`#assoc-panel-${panelIndex}-header`);
    if (!hdr) return 'Section';
    const txtNode = hdr.querySelector<HTMLElement>('.ant-collapse-header-text');
    const text = (txtNode?.innerText ?? hdr.innerText ?? '').trim();
    return text || 'Section';
  }
  onPanelActiveChange(key: string, isActive: boolean): void {
    const idx = this.activeKeys.indexOf(key);
    if (isActive && idx === -1) {
      this.activeKeys = [...this.activeKeys, key];
    } else if (!isActive && idx !== -1) {
      this.activeKeys = this.activeKeys.filter(k => k !== key);
    }
    setTimeout(() => this.makeHeadersFocusable(), 0);
  }

  checkAge(date: string) {
    const [month, day, year] = date.split('/').map(Number);
    const dob = new Date(year, month - 1, day);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    const dayDiff = today.getDate() - dob.getDate();
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }
    this.isConsumerAbove18 = age >= 18;
  }

  async getFileCols() {
    const tempCols = await this.sectionsService.getJsonConfigurationData(
      STATIC_JSON_DATA_PATH.PARTICIPANT_ASSOCIATIONS_HEADERS
    );
    this.associationCols = tempCols?.columns;
  }

  flattenData(data: Record<string, any[]>): any[] {
    return Object.values(data).flat();
}

  getAssociationDetails(program_code: string, participantId: any) {
    console.log('leadId', participantId);
    if(participantId) {
     const isParticipant = this.flow === 'participantEnrollment';
     this.enrollmentDataService.getAssociationsDetails(program_code, participantId, isParticipant, true).subscribe((response: any) => {
      console.log(response.responsedata);
      const data = response.responsedata;
      this.participantAssociations = this.flattenData(response.responsedata);

      for(const key in PROVIDER_TYPES) {
        this.associationDetailsData[key] = data[key] || [];
      }
    });
  }

  }

  action(event: any): void {
    if (event.action === 'disassociate') {
      this.checkAge(this.consumerData.dob);
      if(!this.isConsumerAbove18 &&  this.getDRCount() < 2 && event.data.associationTypeCode == 'AR') {
        this.openDeleteConfirmationPopup();
      }
      else{
        this.openConfirmationPopup(event.data);
      }
    } else if (event.action === 'view') {
      console.log('view event', event);
      this.referralDataService.setAssociationsEditable(true);
      const payload = {
        programCode: this.program.program_code,
        providerId: event.data.providerId,
        providerType: event.data.associationTypeCode,
        partiProviderAssocId: event.data.partiProviderAssocId
      };
      this.enrollmentDataService
      .fetchParticipantAssociations(payload)
      .subscribe((response: any) => {
        console.log('Edit response', response);
        this.referralDataService.setAssociationDetails(response.responsedata);
        this.addAssociation(ENROLLMENT_TYPE_BACKEND_MAPPINGS[event.data.associationTypeCode], EditMode.Add)
        // const flattenedData = this.flattenResponse(response);
        // console.log(flattenedData.responsedata);
        // this.infoForm.patchValue(flattenedData.responsedata);
      });
    }
  }

  disassociate(data: PrtcpntPrvdrAssociationModel){
    const program = this.userService.getSelectedProgram();
    const payload : DeleteAssociationModel = {
      associationType : data.associationTypeCode,
      participantId : data.participantId,
      providerId : data.providerId,
      programCode : program?.program_code ?? '',
      associationId : data.partiProviderAssocId
    };
    this.deleteAccociation(payload);
  }

  deleteAccociation(payload : DeleteAssociationModel){
    this.enrollmentDataService.deleteParticipantProviderAssociation(payload, true).subscribe((response: any) => {
      console.log('Edit response', response);
      this.enrollmentDataService.setParticipantAssocChanged(true);
    });
  }
  

  openConfirmationPopup(data: PrtcpntPrvdrAssociationModel) {
      const dialogConfig: DialogConfig = {
        title: 'Confirmation',
        isOkText: 'Ok',
        size: 'medium',
        position: 'top',
        showClose: true,
        showButtons: true,
      };
  
      this.dialogSvc.openDialog(
        this.confirmationDialog,
        dialogConfig,
        () => this.disassociate(data),
        () => this.handleCancel()
      );
    }
    openDeleteConfirmationPopup() {
      const dialogConfig: DialogConfig = {
        title: 'Error',
        isOkText: 'Ok',
        size: 'medium',
        position: 'top',
        showClose: true,
        showOkButton: true,
        showButtons: false,
      };
  
      this.dialogSvc.openDialog(
        this.deleteConfirmationDialog,
        dialogConfig,
        () => this.handleCancel(),
        () => this.handleCancel()
      );
    }
  
    handleCancel() {}

  async getGridHeaders() {
    try {
      if (this.flow) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.ASSOCIATIONS_DETAILS_HEADERS, this.flow
        );
        this.cols = tempCols.columns;
      }
    } catch {
      // this.logger.debug('Communication logs - Error in getting column data', err);
    }

  }


  async getAssocGridHeaders() {
    try {
      if (this.flow) {
        const tempCols = await this.sectionsService.getJsonConfigurationData(
          STATIC_JSON_DATA_PATH.ALL_ASSOCIATIONS_DETAILS_HEADERS, this.flow
        );
        this.participantCols = tempCols.columns;
      }
    } catch {
      // this.logger.debug('Communication logs - Error in getting column data', err);
    }
  }

  getProviderData(providerCode: string) {
 
    const data =  this.associationDetailsData[providerCode] || [];
    data.forEach((e: any) => {
      if (e.associationStatus != 'Disassociated') {
        e.actions = {
          'showDisassociate': true
        }
      }
    });
    return data;
  }

  getDRCount(){
    const activeDRs = this.associationDetailsData['AR']?.filter(
      (item: any) => item.associationStatus !== 'Disassociated'
    );
    return activeDRs?.length || 0;
  }

  getConsumerDetails() {
    this.leadDetailsService
      .getLeadDetails(this.flow, this.program.program_code, this.participantId, true)
      .subscribe((data: any) => {
        this.consumerData = data?.responsedata?.infoData;
        if(this.consumerData?.dob) {
          this.checkAge(this.consumerData.dob);
        }
      });
  }

  getProviderColumns(providerCode: string) {
    if (!['AR', 'IR', 'LG', 'POA'].includes(providerCode)) {
      let data = this.cols.filter((e: any) => e.field != 'relationToParticipant');
      return data;
    }

    return this.cols;
  }

  checkFieldData(): boolean {
    return Object.values(this.associationDetailsData).some((association: any) => association.length > 0);
    //Do not delete the below commented code

    // if(this.mandatoryAssociations.length === 0 || this.flow === 'providerEnrollment'){
    //   return true;
    // }
    // return this.mandatoryAssociations.every(item => {
    //   const fieldName = item.fieldName.replace('new', '');
    //   const mappedFieldName = ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS[fieldName.toLowerCase()];
    //   return mappedFieldName && this.associationDetailsData[mappedFieldName] && this.associationDetailsData[mappedFieldName].length > 0;
    // });
  }

  onRadioChange(controlName: string, value: string) {
    if (value === 'Yes') {
      this.sectionsService.setEnrollmentType(JSON.stringify([controlName]));
      //this.referralDataService.clearReferrralData();
      this.referralDataService.setFlowForAssociation({ val: true, flow: controlName });
    }
  }

  addAssociation(control: string, editMode?: EditMode){
    this.sectionsService.setEnrollmentType(JSON.stringify([control]));
    if (editMode !== EditMode.Add) {
      this.referralDataService.clearAssociationsFormData();
    }
    //this.referralDataService.clearReferrralData();
    const flowParams: any = { val: true, flow: control }
    if (editMode) {
      flowParams.editMode = editMode;
      console.log("FLOW PARAMS", flowParams)
    }
    this.referralDataService.setFlowForAssociation(flowParams);
    // this.referralDataService.setReferralFormData(
    //   'isAssociationsFormDirty', true
    // );
    // this.referralDataService.setReferralFormData(
    //   'isAssociationsFormUpdated', true
    // );
  }

  // viewAssociation(control: string){
  //   this.enrollmentDataService
  //       .fetchParticipantAssociations(payload)
  //       .subscribe((response: any) => {
  //         console.log('Edit response', response);
  //         const flattenedData = this.flattenResponse(response);
  //         console.log(flattenedData.responsedata);
  //         this.infoForm.patchValue(flattenedData.responsedata);
  //       });
  // }

  hideAll() {
    this.activeKeys = [];
  }

  expandAll() {
    this.activeKeys = ['1', '2', '3', '4', '5', '6', '7'];
  }

  togglePanel(key: string): void {
    if (this.isPanelActive(key)) {
      this.activeKeys = this.activeKeys.filter((k) => k !== key);
    } else {
      this.activeKeys.push(key);
    }
    setTimeout(() => {
      const root = this.hostEl.nativeElement;
      const header = root.querySelector<HTMLElement>(`#assoc-panel-${key}-header`);
      if (header) {
        const expanded = this.isPanelActive(key);
        this.renderer.setAttribute(header, 'aria-expanded', String(expanded));
        this.announce(`${this.getHeaderText(key)} ${expanded ? 'expanded' : 'collapsed'}`);
        if (expanded) {
          this._focusContent(key, header);
        } else {
          this._focusNextHeader(header);
        }
      }
    }, 0);
  }

  isPanelActive(key: string): boolean {
    return this.activeKeys.includes(key);
  }
}
